import { AdditionalServicesResponse, AdditionalServicesResponseItem } from '@/types/service-response'

export class AdditionalServices {
  private constructor (
    readonly id: number,
    readonly addressName: string,
    readonly addressNumber: string,
    readonly addressId: number,
    readonly productId: number,
    readonly productName: string,
    readonly quantity: string,
    readonly price: string,
    readonly total: string,
    readonly currency: string,
    readonly description: string,
    readonly employeeShortName: string,
    readonly employeeId: number,
    readonly employeeNumber: string,
    readonly employeeName: string,
    readonly addressLabel: string,
    readonly employeeLabel: string
  ) {}

  static createListFromResponse (responseData: AdditionalServicesResponse): Array<AdditionalServices> {
    return responseData.map((item: AdditionalServicesResponseItem) => {

      return new AdditionalServices(
        item.ID,
        item.AdressName,
        item.AdressNummer,
        item.AdressID,
        item.ProductID,
        item.ProductName,
        item.Menge.toFixed(3),
        item.Betrag.toFixed(2),
        (Math.round(item.Menge * item.Betrag * 100) /100).toFixed(2),
        item.Waehrung,
        item.Beschreibung,
        item.Kurzzeichen,
        item.Mitarbeiter,
        item.Personalnummer,
        item.VollerName,
        `${item.AdressNummer} ${item.AdressName}`,
        `${item.Kurzzeichen} / ${item.VollerName} (${item.Personalnummer})`
      )
    })
  }
}
